import React, { useEffect, useState } from "react";
import { Box, Divider, Pagination, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import CustomButton from "../../Components/Button/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import CheckIcon from '@mui/icons-material/Check';
import { useDispatch, useSelector } from "react-redux";
import { DeleteFormLabels, V_GetAllFormLabels } from "../../Reducers/dcoi";
import Toster from "../../Components/Common/Toster/Toster";
import ConfirmationModel from "../../Components/Common/DeleteModel/DeleteModel";
import Spinner from "../../Components/Common/Spinner/Spinner";

function VcoiManageFormLabels() {
  const { V_languageList, inProgress } = useSelector((state) => state.dcoi);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState();
  const [severity, setSavirity] = useState();
  const [alert, setAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModel, setDeleteModel] = useState(false);
  const [itemID, setItemID] = useState();
  const itemsPerPage = 20;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    dispatch(V_GetAllFormLabels());
  }, [])



  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = V_languageList.slice(indexOfFirstItem, indexOfLastItem); // Slice filteredItems for pagination
  const SucessDelete = () => {
    try {
      dispatch(DeleteFormLabels({ labelId: itemID })).then((res) => {
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(true);
          setSavirity("success");
          setMessage(res?.payload?.data[0]?.success)
          setDeleteModel(!deleteModel);
          dispatch(V_GetAllFormLabels());
        } else if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setMessage(res?.payload?.data[0]?.error)
          setSavirity("error");
        } else {
          setAlert(true);
          setMessage("Something Went Wrong")
          setSavirity("error");
        }
      })
    } catch {
      setAlert(true);
      setSavirity("error");
      setMessage(`SomeThing Went Wrong..`)
    }

  }

  return (
    <>
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <ConfirmationModel open={deleteModel} handleOpen={() => setDeleteModel(!deleteModel)} SucessDelete={SucessDelete} />
      <div className="headerNavigation">
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
          List of Form Labels
        </Typography>

      </div>
      <Box className="boxAlignment">
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item>
            <CustomButton onClick={() => {
              navigate(`/app-vcoi/vcoisitecontent/VcoiManageFormLabels/VcoiNewFormLabel`)
            }} label="+ ADD NEW FORM LABELS" />
          </Grid>
        </Grid>
        <Box sx={{ overflowX: "auto", width: "100%" }}> {/* Enables horizontal scrolling */}
        <Box sx={{ minWidth: "600px" }}> {/* Prevents shrinking on small screens */}
        <Grid container spacing={2} my={2} alignItems="flex-start" sx={{ fontWeight: "bold", color: "gray"}}>
          <Grid item xs={6} sm={6} md={6}>
            LANGUAGE
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            IN USE
          </Grid>
          <Grid item xs={2} sm={2} md={2}></Grid>
        </Grid>
        <Divider/>
        {/* Content Section */}
        {currentItems.length > 0 ? (<>
              {currentItems.map((item, index) => (
                <React.Fragment key={index}>
                  <Grid container alignItems="center" spacing={2} sx={{ padding: "10px 0px" }}>
                    {/* LANGUAGE */}
                    <Grid item xs={6} sm={6} md={6}>
                      <Typography>{item.Label}</Typography>
                    </Grid>

                    {/* IN USE */}
                    <Grid item xs={4} sm={4} md={4}>
                      <Typography>
                        {item?.InUse ? <CheckIcon color="success" /> : "--"}
                      </Typography>
                    </Grid>

                    {/* Actions - Desktop */}
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      sx={{ display: { xs: "none", sm: "none", md: "flex" }, justifyContent: "right" }}
                    >
                      {!item.InUse && (
                        <Button
                          className="actionButton"
                          variant="contained"
                          startIcon={<DeleteIcon className="actionIcon" />}
                          onClick={() => {
                            setItemID(item.ID);
                            setDeleteModel(!deleteModel);
                          }}
                        >
                          Delete
                        </Button>
                      )}
                      &nbsp;&nbsp;
                      <Button
                        className="actionButton"
                        variant="contained"
                        startIcon={<EditIcon className="actionIcon" />}
                        onClick={() =>
                          navigate('/app-vcoi/Vcoisitecontent/VcoiManageFormLabels/VcoiNewFormLabel', {
                            state: { formLabels: item },
                          })
                        }
                      >
                        Edit
                      </Button>
                    </Grid>

                    {/* Actions - Mobile */}
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      sx={{ display: { xs: "flex", sm: "flex", md: "none" }, justifyContent: "right" }}
                    >
                      {!item.InUse && (
                        <DeleteIcon
                          className="actionIconResponsive"
                          onClick={() => {
                            setItemID(item.ID);
                            setDeleteModel(!deleteModel);
                          }}
                        />
                      )}
                      &nbsp;&nbsp;
                      <EditIcon
                        className="actionIconResponsive"
                        onClick={() =>
                          navigate('/app-vcoi/sitecontent/ManageFormLabels/NewFormLabel', {
                            state: { formLabels: item },
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                  <Divider />
                </React.Fragment>
              ))}

</>) : (
          <>
            {!inProgress && currentItems?.length === 0 && V_languageList?.length === 0 && (
              <Typography sx={{ margin: "20px", textAlign: "center", color: "gray", fontStyle: "italic" }}>
                No Data Found...
              </Typography>
            )}
          </>
        )}
        </Box>
        </Box>

        {currentItems.length > 0 && <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Pagination showFirstButton showLastButton sx={{
            margin: "10px", padding: "5px", border: "1px solid  #212129",
            borderRadius: "20px"
          }} count={Math.ceil(V_languageList.length / itemsPerPage)} page={currentPage} onChange={handlePageChange} /></Box>}
      </Box>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default VcoiManageFormLabels